import { render, staticRenderFns } from "./MerchantBusinessGeneralDetailsManagement.vue?vue&type=template&id=e80a2e26&scoped=true&"
import script from "./MerchantBusinessGeneralDetailsManagement.vue?vue&type=script&lang=js&"
export * from "./MerchantBusinessGeneralDetailsManagement.vue?vue&type=script&lang=js&"
import style0 from "./MerchantBusinessGeneralDetailsManagement.vue?vue&type=style&index=0&id=e80a2e26&scoped=true&lang=css&"
import style1 from "./MerchantBusinessGeneralDetailsManagement.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80a2e26",
  null
  
)

export default component.exports